import React from 'react';
import './index.scss';

const LoadingScreen = ({ className }) => {
  return (
    <div className={`loading-screen load-cover ${className ? className : ''}`}>
      <div className="dot-wrap">
        <div className="dot"></div>
      </div>
    </div>
  )
}

export default LoadingScreen;